export const YOUTUBE_VIDEO_ID_RE = /^[A-Za-z0-9_-]{11}$/;

const ALLOWED_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'music.youtube.com',
  'youtu.be',
  'www.youtu.be',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com',
]);

export function isYouTubeVideoId(value: unknown): value is string {
  return typeof value === 'string' && YOUTUBE_VIDEO_ID_RE.test(value);
}

export function parseYouTubeVideoId(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed || trimmed.length > 500) return null;
  if (trimmed.includes('<') || trimmed.includes('>') || trimmed.includes('"')) return null;
  if (YOUTUBE_VIDEO_ID_RE.test(trimmed)) return trimmed;

  let candidateInput = trimmed;
  if (!/^https?:\/\//i.test(candidateInput)) {
    candidateInput = `https://${candidateInput}`;
  }

  let url: URL;
  try {
    url = new URL(candidateInput);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  const host = url.hostname.toLowerCase();
  if (!ALLOWED_HOSTS.has(host)) return null;

  let candidate: string | null = url.searchParams.get('v');
  const pathParts = url.pathname.split('/').filter(Boolean);
  const hostBare = host.replace(/^www\./, '');
  if (!candidate && hostBare === 'youtu.be') candidate = pathParts[0] ?? null;
  if (!candidate && pathParts.length >= 2) {
    const kind = pathParts[0]!.toLowerCase();
    if (kind === 'shorts' || kind === 'embed' || kind === 'live' || kind === 'v') {
      candidate = pathParts[1] ?? null;
    }
  }
  if (!candidate) return null;
  const id = candidate.split('?')[0]!.split('&')[0]!.split('#')[0]!;
  return isYouTubeVideoId(id) ? id : null;
}

export function youtubeThumbnailUrl(videoId: string): string | null {
  if (!isYouTubeVideoId(videoId)) return null;
  return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
}
